// extracted by mini-css-extract-plugin
export var author = "Quote-module--author--ZVCwF";
export var authorName = "Quote-module--authorName--ts5cZ";
export var authorSubline = "Quote-module--authorSubline--Z1yVj";
export var quote = "Quote-module--quote--wz9Pb";
export var root = "Quote-module--root--7S4sF";
export var text = "Quote-module--text--uZWY7";